import { getOr, getEq, reduce } from 'utils/immutable'
import { compose, match, head } from 'ramda'

const numberAtEnd = compose(head, match(/(\d+)$/))
const getDescriptionNextIndex = (
  collection,
  nodeType = null,
  prefix = null
) => {
  if (!collection || collection.isEmpty()) return 1
  const descriptionNumber = compose(numberAtEnd, getOr('', 'description'))

  const maxIndex = reduce((acc, current) => {
    if (nodeType && !getEq('queryType', nodeType)(current)) return acc

    if (prefix !== null) {
      const desc = getOr('', 'description')(current)
      // Match only exact generated names: "<prefix> <digits>" with nothing else
      if (!new RegExp(`^${prefix} \\d+$`).test(desc)) return acc
    }

    const currentNumber = parseInt(descriptionNumber(current), 10)
    if (currentNumber > acc) return currentNumber
    return acc
  }, 0)(collection)

  return maxIndex + 1
}

export { getDescriptionNextIndex }
